export default "__VITE_ASSET__CeyedcBd__"